import React from 'react';
import { View } from 'react-native';

import * as _ from 'lodash';
import PropTypes from 'prop-types';

import { Icon, VFText } from '@vfgroup-oneplatform/foundation/Components';
import { useTheme } from '@vfgroup-oneplatform/foundation/Components/Themes';
import { DateCurrencyFromatter } from '@vfgroup-oneplatform/foundation/Utils';

import { getThemeImages } from '../../../../Themes';

import styles from './PlanHeader.Styles';

const PlanHeader = ({
  plan,
  isActive,
  isRecommended,
  planNameTextStyle,
  numberOfLines,
  ...props
}) => {
  const theme = useTheme();
  const Images = getThemeImages(theme.name);
  const { name, price, renderCustomPrice, currency, leftIcon = Images.icAccelerationMid } = plan;
  const icon = !isActive
    ? Images.TImages.ic_chevron_down.primary
    : Images.TImages.ic_chevron_up.primary;
  const { currencyTransformer } = DateCurrencyFromatter.dateCurrencyFromatter;

  return (
    <View {...props} style={styles.planHeaderContainer(isActive, isRecommended)}>
      <Icon style={styles.headerIcon} name={leftIcon} type="image" />
      <View style={styles.planNameContainer}>
        <VFText numberOfLines={numberOfLines} style={[styles.planNameText, planNameTextStyle]}>
          {name}
        </VFText>
        {_.isFunction(renderCustomPrice) ? (
          renderCustomPrice()
        ) : (
          <View style={styles.priceContainer}>
            <VFText style={styles.planPrice}>
              {props.isCurrencyFirst
                ? `${currency}${currencyTransformer(price, 0)}`
                : `${currencyTransformer(price, 0)}${currency}`}
            </VFText>
            <View style={styles.dateContainer}>
              <VFText style={styles.monthText}>/</VFText>
              <VFText style={styles.monthText} i18nKey="addons_default_addon_period" />
            </View>
          </View>
        )}
      </View>
      <Icon name={icon} type="image" />
    </View>
  );
};

PlanHeader.propTypes = {
  plan: PropTypes.object,
  isActive: PropTypes.bool,
  isRecommended: PropTypes.bool,
  planNameTextStyle: PropTypes.object,
  numberOfLines: PropTypes.number,
  isCurrencyFirst: PropTypes.bool,
};

export default PlanHeader;
